module.exports = __webpack_public_path__ + "static/img/IM.fe07756f.png";